import React from 'react';
import { useState } from 'react';
import {
  createPathway,
  getRecommendedCoursesAPI,
  getUserName,
} from '../../../hooks';
import { PathwayItemComponent, PathwaySearch } from '../../../components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CreatePathwayContentView = () => {
  const { t } = useTranslation('library');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [description, setDescription] = useState('');
  const [subject, setSubject] = useState('');
  const [selectedData, setSelectedData] = useState([]);

  const navigate = useNavigate();

  const recommendedCoursesCallback = (recommendedCourses) => {
    setSearchResults([...selectedData, ...recommendedCourses]);
  };

  const handleAddContentClick = () => {
    setIsPopUpOpen(true);
  };

  const handleSavePathwayClick = () => {
    const items = searchResults.map((item) => ({
      item_type: 'course',
      course_id: item?.course_id || item?._source?.course_id,
    }));

    const payload = {
      pathway_id: getUserName() + '_' + searchTerm,
      username: getUserName(),
      name: searchTerm,
      path: items,
      visible: false,
      data: {
        description: description,
        banner_image: '',
        subject: subject,
      },
    };

    createPathway(JSON.stringify(payload), (data) => {
      navigate('/profile/pathways/');
    });
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setSearchTerm(inputValue);

    if (inputValue.trim() === '' || inputValue.length < 2) {
      setSearchResults([]);
      return;
    }

    const delay = 500;
    setTimeout(() => {
      getRecommendedCoursesAPI(inputValue, recommendedCoursesCallback);
    }, delay);
  };

  const handleRemoveItemClick = (courseId) => {
    const updatedResults = searchResults.filter(
      (item) =>
        item?.course_id !== courseId && item?._source?.course_id !== courseId
    );
    setSearchResults(updatedResults);
  };

  return (
    <>
      <div className="add_pathway_div">
        <div className="path_cover">
          <div className="pathway_div-2 dashboard">
            <div className="div-block-122">
              <div className="div-block-121"></div>
            </div>
          </div>
        </div>
        <div className="courses0-2 exp profile spec">
          <div className="div-block-120">
            <div className="div-block-113" style={{ display: 'none' }}>
              <img
                alt=""
                className="image-55"
                loading="lazy"
                src="images/photo-camera-interface-symbol-for-button_1photo-camera-interface-symbol-for-button.png"
              />
              <div className="text-block-81">{t('Change cover image')}</div>
            </div>
          </div>
          <div className="info_box">
            <div className="div-block-114">
              <div className="tinymce__form-block w-form">
                <form
                  className="tinymce__form"
                  data-name="Email Form"
                  data-wf-element-id="ab8c683f-7031-f8a4-e257-5ed2d9e593dc"
                  data-wf-page-id="6596e21ac435cac3c66baae0"
                  id="email-form"
                  method="get"
                  name="email-form"
                >
                  <label className="form_text" htmlFor="name-2">
                    {t('Pathway name*')}
                  </label>

                  <input
                    className="form_input w-input"
                    data-name="Name 2"
                    id="pathwayName"
                    maxLength={256}
                    name="pathwayName"
                    value={searchTerm}
                    onChange={(e) => handleInputChange(e)}
                    placeholder=""
                    type="text"
                  />

                  <label className="form_text" htmlFor="email">
                    {t('Description')}
                  </label>
                  <textarea
                    className="tinymce__text-area w-input"
                    data-name="Tinymce"
                    value={description}
                    id="tinymce"
                    maxLength={5000}
                    name="tinymce"
                    placeholder=""
                    onChange={(e) => setDescription(e.target.value)}
                  />

                  <div className="div-block-118">
                    <div className="div-block-116">
                      <label htmlFor="email" className="form_text">
                        {t('Subject')}
                      </label>
                      <input
                        type="text"
                        className="form_input w-input pathway-subject"
                        maxLength={256}
                        name="name-2"
                        data-name="Name 2"
                        placeholder=""
                        value={subject}
                        id="name-2"
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </div>
                  </div>
                </form>
                <div className="w-form-done">
                  <div>
                    {t('Thank you! Your submission has been received!')}
                  </div>
                </div>
                <div className="w-form-fail">
                  <div>
                    {t('Oops! Something went wrong while submitting the form.')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="units_block dashboard">
            <div className="unit_num">
              <div className="number-2 last">
                <div className="l_top sm" />
                <div className="div-block-72 sm">
                  <div className="div-block-70">
                    <img
                      style={{ display: 'none' }}
                      alt=""
                      className="image-46"
                      loading="lazy"
                      src="images/62a334c5a2b21b82f0ac43fc_hexagon_162a334c5a2b21b82f0ac43fc_hexagon.png"
                    />
                    <div className="num reg">3</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="unit_listing">
              {searchResults?.map((data, index) => {
                const courseId = data?.course_id || data?._source?.course_id;
                return (
                  <PathwayItemComponent
                    key={index}
                    data={data}
                    index={index}
                    handleRemoveItemClick={() =>
                      handleRemoveItemClick(courseId)
                    }
                  />
                );
              })}
              <div
                className="content_parent"
                onClick={handleAddContentClick}
                style={{ marginTop: '20px' }}
              >
                <div className="add_content_div last">
                  <img
                    src="/images/plus.png"
                    loading="lazy"
                    alt=""
                    className="image-55"
                  />
                  <div className="text-block-80">{t('Add Content')}</div>
                </div>
              </div>
            </div>
          </div>
          {searchResults.length > 0 && (
            <div
              className="div-block-120 save-pathway-div"
              style={{ marginTop: '40px' }}
              onClick={handleSavePathwayClick}
            >
              <div className="div-block-113 save-pathway">
                <div className="text-block-81">{t('Save Pathway')}</div>
              </div>
            </div>
          )}
        </div>
      </div>

      {isPopUpOpen && (
        <PathwaySearch
          popUpCallBack={setIsPopUpOpen}
          setPathwayData={setSearchResults}
          pathwayData={searchResults}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
        />
      )}
    </>
  );
};

export { CreatePathwayContentView };
